import { BillingCycleTypes } from '../../domain/invoice';
import { LicenseStatusTypes, LiveHubConnectionStatuses } from '../../domain/license';
import { ISortable } from '../../../../app/helpers/sort';

export enum sortTypes {
    ID = 0,
    MemberID = 1,
    MemberFirstName = 2,
    MemberLastName = 3,
    Product = 4,
    BillingCycle = 5,
    NextBillDate = 6,
    Key = 7,
    Version = 8,
    Status = 9,
    HasNotes = 10,

    Company = 20,
    Email = 21,
    Phone = 22,
    Phone2 = 23,
    Address1 = 24,
    City = 26,
    State = 27,
    ZipCode = 28,
    Country = 29,
    Fax = 30,

    SalesRep = 40,
    CreditCardLastFour = 41,

    Note = 50,
    NoteCreated = 51,


    GISBundlePurchaseDate = 61,
    GISBundleExpireDate = 62,
    GISBundleStartDate = 63,

    GISUsageDate = 65,

    CreationDate = 70,
    CancellationDate = 71,

    DesignerName = 100,


}

export enum sortDirection {
    Ascending = 0,
    Descending = 1,
    Unsorted = 2,
    SingleItem = 3,
    NotSpecified = 4
}

export interface IMemberDashboardLicenseResponse {

    ID: number;
    MemberID: number;
    MemberFirstName: string;
    MemberLastName: string;
    Product: string;
    StartDate: Date;
    BillingCycle: BillingCycleTypes;
    NextBillDate: Date;
    Key: string;
    Version: string;
    Status: LicenseStatusTypes;
    HasNotes: boolean;
    OwnedByDesigner: boolean;
    LegacyDesignerName: string;
    IsLegacyAccount: boolean;

    Transfer_To_MemberID: number;
    Transfer_To_Member: string;
    Transfer_From_MemberID: number;
    Transfer_From_Member: string;
    DateTimeTransferedTo: Date;
    Yard: boolean;
    YardServiceID: number;
    YardCancelled: boolean;
    IsAssigned: boolean;

    ImagingCredits: number;
    
    TOSWindow: boolean;

    LiveHubConnectionStatus: LiveHubConnectionStatuses;
    LiveHubDateTimeConnectionStarted: Date;
    LiveHubDateTimeConnectionStopped: Date;
    DragonrollVersion: string;
    LiveHubVersion: string; 
}

export interface ISortItem {
    SortType: sortTypes;
    SortDirection: sortDirection;
    SortCol: string;
}

export class SortItem implements ISortItem {
    SortType: sortTypes;
    SortDirection: sortDirection;
    SortCol: string;

    constructor() {
        this.SortType = sortTypes.ID;
        this.SortDirection = sortDirection.NotSpecified;
    }

}


export class MemberDashboardLicenseResponse implements IMemberDashboardLicenseResponse {

    ID: number;
    MemberID: number;
    MemberFirstName: string;
    MemberLastName: string;
    Product: string;
    StartDate: Date;
    BillingCycle: BillingCycleTypes;
    BillingAmount: number;
    NextBillDate: Date;
    DateTimeCreated: Date;
    Key: string;
    Version: string;
    Status: LicenseStatusTypes;
    HasNotes: boolean;
    OwnedByDesigner: boolean;
    LegacyDesignerName: string;
    IsLegacyAccount: boolean;
    Yard: boolean;
    YardServiceID: number;
    YardCancelled: boolean;
    IsAssigned: boolean;

    ImagingCredits: number;

    TOSWindow: boolean;

    Transfer_To_MemberID: number;
    Transfer_To_Member: string;
    Transfer_From_MemberID: number;
    Transfer_From_Member: string;
    DateTimeTransferedTo: Date;

    LiveHubConnectionStatus: LiveHubConnectionStatuses;
    LiveHubDateTimeConnectionStarted: Date;
    LiveHubDateTimeConnectionStopped: Date;
    DragonrollVersion: string;
    LiveHubVersion: string;

    public static FixDate(license: MemberDashboardLicenseResponse) {
        license.NextBillDate = new Date(license.NextBillDate);
        license.DateTimeCreated = new Date(license.DateTimeCreated);
        license.LiveHubDateTimeConnectionStarted = new Date(license.LiveHubDateTimeConnectionStarted);
        license.LiveHubDateTimeConnectionStopped = new Date(license.LiveHubDateTimeConnectionStopped);
    }

}

export class MemberDashboardLicenseResponseArray extends Array<MemberDashboardLicenseResponse> implements ISortable  {

    public LastSort = new SortItem;

    constructor(...items: MemberDashboardLicenseResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberDashboardLicenseResponseArray.prototype);
    }

    public static initVariables(myArray: MemberDashboardLicenseResponseArray): MemberDashboardLicenseResponseArray {
        myArray.LastSort = new SortItem;
        myArray.LastSort.SortType = sortTypes.ID;
        myArray.LastSort.SortDirection = sortDirection.NotSpecified;
        return myArray;
    }

    public static FixDates(licenses: MemberDashboardLicenseResponseArray) {

        licenses.forEach(x => {
            x.NextBillDate = new Date(x.NextBillDate);
            x.DateTimeTransferedTo = new Date(x.DateTimeTransferedTo);
            x.LiveHubDateTimeConnectionStarted = new Date(x.LiveHubDateTimeConnectionStarted);
            x.LiveHubDateTimeConnectionStopped = new Date(x.LiveHubDateTimeConnectionStopped);
        });

    }


}
